import Tool, {
  type ToolArgsWithController,
  type ToolArgs,
} from '../../../tools/Tool';
import expandSvg from '../../../assets/icons/expand.svg';
import { svgToIcon } from '../../../components/Toolbar/toolbarUtils';
import { Editor } from 'slate';
import { isImageElement } from '../../../types/guards';
import type { ImageElement } from '../../../types/aha-editor';

class ToolImageViewer extends Tool {
  static toolName = 'View image';

  static action({ editor, controller, element }: ToolArgsWithController): void {
    const mediaProvider = controller.ahaEditor.getProvider('media');
    if (!mediaProvider) return;

    const image = this.imageElement({ editor, element });
    if (!image) return;

    mediaProvider.onViewImage(image.media_src);
  }

  static renderToolbarButtonIcon(): JSX.Element {
    return svgToIcon(expandSvg);
  }

  static isEnabled({ editor, element }: ToolArgs): boolean {
    const image = this.imageElement({ editor, element });
    if (!image) return false;

    // Disable making an image fullscreen if the src is the placeholder.
    // This is so the image cannot be enlarged while it's still uploading.
    return Boolean(
      image.media_src && !image.media_src.startsWith('placeholder:')
    );
  }

  static imageElement({ editor, element }: ToolArgs): ImageElement | undefined {
    if (element && isImageElement(element)) {
      return element;
    } else {
      const image = Editor.above(editor, {
        match: isImageElement,
      });

      if (image) {
        return image[0];
      }
    }
  }
}

export default ToolImageViewer;
